import {useCallback} from 'react';
import validatejs from 'validate.js';

export default function useValidation(validationSchema: {}) {
  return useCallback(
    (data: {}) => {
      const validation = validatejs(data, validationSchema, {fullMessages: false});
      if (validation) {
        for (const key in validation) {
          validation[key] = validation[key][0];
        }

        return validation;
      }
      return null;
    },
    [validationSchema],
  );
}
